module.exports = __webpack_public_path__ + "23e43c1312ca640b6f57c3b2b557de4a.gif";